module.exports = __webpack_public_path__ + "assets/img/block-left-79b03423.png";